require('@zalando-internal/z-shop-ui/dist/z-shop-ui.css');

var wrapper = document.createElement('div');
wrapper.className = 'z-svg-res-container';
wrapper.innerHTML = require('@zalando-internal/z-shop-ui/dist/icons.svg');
// Icons shouldn't have gradients, they may not render them because of hidden div
wrapper.style.display = 'none';

// Insert on top of everything in the body to not break the fragment identification
// Polling is needed since document.body is null for hidden tabs in Firefox
(function pollForBody() {
    if (document.body) {
        document.body.insertBefore(wrapper, document.body.firstChild);
    } else {
        setTimeout(pollForBody, 30);
    }
})();

exports['z-shop-ui'] = require('@zalando-internal/z-shop-ui');
